var _path, _path2, _ellipse, _circle, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedicine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2066 9.05V16.2H3.98438L3.98438 9.05V8.49999H4.00929C4.28998 5.41642 6.90769 3 10.0955 3C13.2833 3 15.901 5.41642 16.1817 8.49999H16.2066V9.05Z",
    fill: "#DCDCE4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.98481 18.95L3.98481 14L10.0743 14C10.0815 14 10.0887 14 10.0959 14C10.1031 14 10.1103 14 10.1175 14L16.207 14L16.207 18.95L16.207 19.5L16.1821 19.5C15.9014 22.5836 13.2837 25 10.0959 25C6.90813 25 4.29042 22.5836 4.00973 19.5L3.98481 19.5L3.98481 18.95Z",
    fill: "#6A6A71"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.873,
    cy: 17.8223,
    rx: 5,
    ry: 5,
    transform: "rotate(-180 17.873 17.8223)",
    fill: "#696970"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.9434,
    cy: 17.822,
    r: 5,
    transform: "rotate(-135 16.9434 17.822)",
    fill: "url(#paint0_linear_20957_12612)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20957_12612",
    x1: 17.0647,
    y1: 17.9986,
    x2: 16.0014,
    y2: 26.8948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#DCDCE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0002,
    stopColor: "#F5F5FA"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicine);
export default __webpack_public_path__ + "static/media/medicine.2731e813823ef0b97862ffc59b077ed1.svg";
export { ForwardRef as ReactComponent };